import React from "react";
import styled from "styled-components";

const ListView = props => {
  const { list, active } = props;
  return (
    <Container>
      {list.map((l, i) => (
        <Item>
          <img
            src={l.thumb}
            alt="Doc1"
            style={{
              resizeMode: "cover",
              width: "100%",
              height: "100%",
              filter: active === i ? "grayscale(0)" : "grayscale(1)",
              opacity: active === i ? 1 : 0.4
            }}
          />
        </Item>
      ))}
    </Container>
  );
};

const Container = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding-top: 20px;
`;

const Item = styled.div`
  width: 200px;
  height: 150px;
  margin-bottom: 20px;
`;
export default ListView;
